import { render } from "./ColorBuilder.vue?vue&type=template&id=12606b5b&scoped=true"
import script from "./ColorBuilder.vue?vue&type=script&lang=js"
export * from "./ColorBuilder.vue?vue&type=script&lang=js"

import "./ColorBuilder.vue?vue&type=style&index=0&id=12606b5b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-12606b5b"

export default script